exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rowsPerPageClass[data-v-4ca14c94] {\n    display: inline-block;\n    width: 100px;\n    padding: 6px;\n}\n", ""]);

// exports
